import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionConfigCombinedHeaderContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    backgroundColor: "fill-surface-raised",
    blockSize: "50px",
    borderBlockEndColor: "border-primary-default",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    paddingBlock: "100",
    paddingInlineStart: "300",
    paddingInlineEnd: "200",
    marginInlineStart: "0",
    alignItems: "center",
    justifyContent: "space-between",
    children: children
  });
};
export default ActionConfigCombinedHeaderContainer;